import { ContentActivity } from "./metrics/ContentActivity";

export const WebsiteContentMetrics = () => <ContentActivity />;
